// frontend/src/serviceWorkerRegistration.ts

export function registerServiceWorker() {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
        // In local development, unregister service workers to avoid stale HMR caches
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (const registration of registrations) {
                    registration.unregister();
                }
            });
            return;
        }

        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/sw.js')
                .then((registration) => {
                    console.log('[PWA] Service Worker registered with scope:', registration.scope);

                    registration.onupdatefound = () => {
                        const installingWorker = registration.installing;
                        if (installingWorker == null) return;

                        installingWorker.onstatechange = () => {
                            if (installingWorker.state === 'installed') {
                                if (navigator.serviceWorker.controller) {
                                    // New version available — fire custom event for toast UI
                                    console.log('[PWA] New content is available.');
                                    window.dispatchEvent(new CustomEvent('sw-update-available'));
                                } else {
                                    // First install — content is now cached for offline use
                                    console.log('[PWA] Content is cached for offline use.');
                                    window.dispatchEvent(new CustomEvent('sw-cached'));
                                }
                            }
                        };
                    };
                })
                .catch((error) => {
                    console.warn('[PWA] Service Worker registration failed:', error);
                });
        });
    }
}
